import clearSessionAndCookieItem from "./utils/clearSessionAndCookieItem";
import {
  extractBaseServer,
  extractDomain,
  API_HEADERS,
  ENDPOINTS,
  MIDDLEWARE,
} from "./utils/index";
import {
  PAGE_ERROR_MAPPING,
  DEFAULT_ERROR_PAGE,
} from "./utils/pageErrorMappings";

export const fetchLoginData = async (middleware, page_name) => {
  try {
    const baseServer = extractBaseServer(window.location.host);
    const domain = extractDomain();
    const loginUrl = `${
      middleware || MIDDLEWARE
    }${ENDPOINTS.getUserData}?domain=${domain}`;

    const response = await fetch(loginUrl, {
      method: "GET",
      headers: {
        ...API_HEADERS,
        baseserver: baseServer,
      },
      credentials: "include",
    });
  
    if (!response.ok) {
      sessionStorage.removeItem('persist:root');
      sessionStorage.removeItem('searchMode');
      localStorage.removeItem("isRevamp");
      if (response && response.status === 401) {
        const keysToClear = [
          "chatCount",
          "chatServiceEnabled",
          "lastChatFetchTime",
          "userDetails",
          "initialVisit",
          "SESSION_STORAGE_SUBUID",
          "CLEVERTAP_PAGE_TRACKING",
          "dowdowloadsData",
          "dowloadsData",
          "alreadyDownloaded",
          "downloadsInProgress",
          "C",
          'persist:root',
          'searchMode',
          
        ];

        keysToClear.forEach(clearSessionAndCookieItem);
        localStorage.removeItem("downloadLeader");
        localStorage.removeItem("sessionId");
        
        // 🔁 Notify all tabs to logout
        const logoutChannel = new BroadcastChannel("logout-channel");
        logoutChannel.postMessage({ type: "LOGOUT" });
        logoutChannel.close();

        window.location.href = domain;
      } else {
        sessionStorage.removeItem('persist:root');
        sessionStorage.removeItem('searchMode');
        sessionStorage.setItem("prevUrl", window.location.href);
        window.location.href = `${
          window.location.origin
        }${
          PAGE_ERROR_MAPPING[page_name] || DEFAULT_ERROR_PAGE
        }`;
      }

      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const loginData = await response.json();
    sessionStorage.setItem("userDetails", JSON.stringify(loginData));

    return loginData;
  } catch (error) {
    console.error("loginError", error);
    return null;
  }
};
